import Vue from 'vue'
import VueRouter from 'vue-router'
import * as VueGoogleMaps from 'vue2-google-maps'
import BootstrapVue from 'bootstrap-vue'

import Home from './components/Home.vue'
import About from './components/About.vue'
import Syrups from './components/Syrups.vue'
import Energy from './components/Energy.vue'
import Kolectiva from './components/Kolectiva.vue'
import SoilStudy from './components/SoilStudy.vue'
import Services from './components/Services.vue'
import Contact from './components/Contact.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './index.scss'

Vue.use(VueRouter)

Vue.use(BootstrapVue)

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_API_KEY
  }
})

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        default: Home
      }
    },
    {
      path: '/nosotros',
      name: 'about',
      components: {
        default: About
      }
    },
     {
      path: '/jarabes',
      name: 'syrups',
      components: {
        default: Syrups
      }
    },
    {
      path: '/pedidos',
      name: 'services',
      components: {
        default: Services
      }
    },
    {
      path: '/contacto',
      name: 'contact',
      components: {
        default: Contact
      }
    },
    {
      path: '/nutrición',
      name: 'energy',
      components: {
        default: Energy
      }
    },
    {
      path: '/kolectiva',
      name: 'kolectiva',
      components: {
        default: Kolectiva
      }
    },
    {
      path: '/agrícola',
      name: 'soilStudy',
      components: {
        default: SoilStudy
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {x: 0, y: 0}
  }
})

new Vue({
  router,
  render: h => h('router-view'),
}).$mount('#app')
